// common/request/index.js
import { pub } from '../event';
import configfile from '../config';
import axios from 'axios';

const IS_DEV = process.env.NODE_ENV === 'development';
const IS_DEBUG = IS_DEV && process.env.VUE_APP_DEBUG === 'true';

let baseUrl;
if (configfile.port) baseUrl = `${configfile.host}:${configfile.port}/`;
else baseUrl = `${configfile.host}/api/`;
const config_custom = { host: baseUrl };

const AUTH_WHITE_LIST = [/\/login\b/, /\/auth\/login\b/, /\/refresh-token\b/];

let redirectingToLogin = false;
function redirectToLogin() {
  if (redirectingToLogin) return;
  redirectingToLogin = true;
  ['token', 'refreshToken', 'user', 'currentStationId', 'openedTabs'].forEach((k) =>
    localStorage.removeItem(k)
  );
  pub('gologinpage', {});
  setTimeout(() => (redirectingToLogin = false), 1000);
}

function getRequestStationId() {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    const user = JSON.parse(userStr);
    if (user.role === 'super_admin') return localStorage.getItem('currentStationId') || null;
    return null;
  } catch (e) {
    return null;
  }
}

function makeQueryStr(obj) {
  const usp = new URLSearchParams();
  for (const k in obj) {
    if (obj[k] !== null && obj[k] !== undefined) usp.append(k, obj[k]);
  }
  const s = usp.toString();
  return s ? '?' + s : '';
}

function extractMessage(error) {
  const body = error?.response?.data;
  if (body && typeof body === 'object') return body.message || body.msg || body.error || '请求失败';
  if (error?.message) return error.message;
  return '网络请求失败';
}

axios.interceptors.request.use(
  (config) => {
    if (IS_DEBUG) { /* console.log('[Request]', config.url); */ }
    if (AUTH_WHITE_LIST.some((r) => r.test(config.url || ''))) return config;
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }
    redirectToLogin();
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    if (IS_DEBUG) { /* console.log('[Response]', response); */ }
    if (response.config.responseType === 'blob') return response;
    if (response.data && response.data.success === false) return Promise.reject(response.data);
    return response.data;
  },
  (error) => {
    const status = error.response?.status || error.status;
    if (status === 401) {
      redirectToLogin();
    } else if (error.response) {
      pub('request_error', { message: extractMessage(error), status });
    }
    return Promise.reject({ success: false, message: extractMessage(error), status });
  }
);

function devErr(...args) {
  if (IS_DEV) console.error(...args);
}

const fengPost = async (url, data, config) => {
  const stationId = getRequestStationId();
  if (stationId) {
    data = data || {};
    if (!data.station_id) data.station_id = stationId;
  }
  if (url.indexOf('http') !== 0) url = config_custom.host + url;
  try {
    const ret = await axios.post(url, data, config);
    if (config && config.responseType === 'blob') return ret.data;
    return ret;
  } catch (error) {
    devErr('请求错误:', error);
    return Promise.reject(error);
  }
};

const fengGet = async (url, query) => {
  const stationId = getRequestStationId();
  if (stationId) {
    query = query || {};
    if (!query.station_id) query.station_id = stationId;
  }
  const querystr = query ? makeQueryStr(query) : '';
  if (url.indexOf('http') !== 0) url = config_custom.host + url;
  try {
    return await axios.get(url + querystr);
  } catch (error) {
    devErr('请求错误:', error);
    return Promise.reject(error);
  }
};

const fengPut = async (url, data) => {
  const stationId = getRequestStationId();
  if (stationId) {
    data = data || {};
    if (!data.station_id) data.station_id = stationId;
  }
  if (url.indexOf('http') !== 0) url = config_custom.host + url;
  try {
    return await axios.put(url, data);
  } catch (error) {
    devErr('请求错误:', error);
    return Promise.reject(error);
  }
};

const fengDelete = async (url, data) => {
  const stationId = getRequestStationId();
  if (stationId) {
    data = data || {};
    if (!data.station_id) data.station_id = stationId;
  }
  if (url.indexOf('http') !== 0) url = config_custom.host + url;
  try {
    return await axios.delete(url, { data });
  } catch (error) {
    devErr('请求错误:', error);
    return Promise.reject(error);
  }
};

export default {
  install(app) {
    app.config.globalProperties.$r = {
      get: fengGet,
      post: fengPost,
      put: fengPut,
      delete: fengDelete,
    };
  },
  api: { get: fengGet, post: fengPost, put: fengPut, delete: fengDelete },
};